import {h} from 'preact';
import ReorderSummary from '../ReorderSummary';
import Summary from '../Summary';

function groupLinesByType ( lineItems = [] ) {
    return lineItems.reduce( ( acc, next ) => {
        next.autoAddedItem
            ? acc.promotionalItems.push( next )
            : acc.lineItems.push( next );

        return acc;
    }, {lineItems: [], promotionalItems: []} );
}

const CartContent = ( {cart = {lineItems: []}, suggestedProducts, render} ) =>
    <div data-testid="cart-content" className="flex flex-col w-full h-full bg-grey-lightest">
        <ReorderSummary list={suggestedProducts}/>
        {render &&
        <div data-testid="cart-content-preview" id="cart-preview"
             className="w-full h-full max-h-full overflow-y-auto scrolling-touch">
            {render( {groupedLines: groupLinesByType( cart.lineItems )} )}
        </div>
        }
        <Summary cart={cart}/>
    </div>;

export default CartContent;
